import { __awaiter, __generator } from "tslib";
import { createDeprecatedInputDriver } from '../../primitives/deprecated-input/driver';
import { CheckboxGroupKey } from '.';
import { createCheckboxDriver } from '../../primitives/drivers';
export var createCheckboxGroupDriver = function (wrapper) {
    var base = wrapper.$("." + CheckboxGroupKey);
    var selectAllWrapper = base.$('.select-all-wrapper');
    var selectAllCb = createCheckboxDriver(selectAllWrapper);
    var limitMessage = base.$('.message-box');
    var getItemByName = function (name) {
        return base.$$('.item-checkbox .checkbox-label').filter(function (el) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, el.text()];
                case 1: return [2 /*return*/, (_a.sent()).includes(name)];
            }
        }); }); }).get(0);
    };
    return {
        labels: function () { return base.$$('.checkbox-label').text(); },
        disabledLabels: function () { return base.$$('.checkbox.disabled .checkbox-label').text(); },
        selectedLabels: function () { return base.$$('.checkbox.checked .checkbox-label').text(); },
        toggle: function (idx) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, base.$$('.item-checkbox input').get(idx).click()];
            });
        }); },
        toggleSelection: function (idx) { return base.$$('.item-checkbox .checkbox-body').get(idx).click(); },
        toggleSelectionByText: function (text) { return getItemByName(text).click(); },
        search: function (term) { return createDeprecatedInputDriver(base).set(term); },
        selectionCounts: function () { return base.$('.selection-count-details').text(); },
        hasSearchHeader: base.$('.select-all-header').exists,
        hasSelectAll: selectAllWrapper.exists,
        isSelectAllDisabled: function () { return selectAllCb.isDisabled(); },
        allSelected: selectAllCb.value,
        selectAll: selectAllCb.toggle,
        deselectAll: function () { return selectAllCb.set(false); },
        isDeselectAllExists: function () { return base.$('.deselect-all-button').exists(); },
        hasLimitMessage: limitMessage.exists,
        limitMessageCount: function () { return limitMessage.text().then(function (str) {
            var m = str.match(/\d+/);
            if (m) {
                return parseInt(m[0], 10);
            }
            throw new Error('cannot parse limit messages text');
        }); },
        isSearchMoreResultsExists: function () { return base.$('.more-search-values-container').exists(); },
        getHeaders: function () { return base.$$('.checkbox-group-header').map(function (item) { return item.text(); }); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map